import React, { Component } from 'react';
import { Link } from 'react-router';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Input, Breadcrumb } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import DropZone from "react-dropzone";
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import ZoneForm from '../../containers/Inventories/zoneForm';
import { ROOT_URL, companyCodeTitle, isVAK, isSV, isAGD, isGFD, isCT } from '../../actions/root_url';
import TranslateName from '../../containers/Translate/translate';


const renderSearchField = props => <Input {...props.input} standalone type="text" placeholder="Search Zone..." />;

class WarehouseForm extends Component {
    static contextTypes = {
      router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,
        allRows: [],
        rows: [],
        selectedRows: [],
        selectedBinRows: [],
        selectedLevelRows: [],
        zone: null,
        bin: null,
        level: null,
        bins: [],
        levels: [],
        filters: {},
        zoneOpen: false,
        title: '',
        binSelected: false,
        levelSelected: false,
        currentZone: null,
        currentBin: null,
        currentLevel: null,
        levelRows: null,
        binRows: null,
        modalOpen: false,
        binOpen: false,
        binSaveOpen: false,
        hierarchy: null,
        levelSaveOpen: false,
        file: null,
        binRow: null,
      };

      this.handleResize = this.handleResize.bind(this);
      this.searchZones = this.searchZones.bind(this);
      this.openZone = this.openZone.bind(this);
      this.closeZone = this.closeZone.bind(this);
      this.closeModal = this.closeModal.bind(this);
      this.openModal = this.openModal.bind(this);
      this.deleteBin = this.deleteBin.bind(this);
      this.createBin = this.createBin.bind(this);
      this.createLevel = this.createLevel.bind(this);
      this.openBin = this.openBin.bind(this);
      this.closeBin = this.closeBin.bind(this);
      this.openLevel = this.openLevel.bind(this);
      this.closeLevel = this.closeLevel.bind(this);
      this.binCloseSave = this.binCloseSave.bind(this);
      this.binOpenSave = this.binOpenSave.bind(this);
      this.levelOpenSave = this.levelOpenSave.bind(this);
      this.levelCloseSave = this.levelCloseSave.bind(this);
      this.deleteLevel = this.deleteLevel.bind(this);
    }

    componentDidMount() {
      document.title = companyCodeTitle;
      window.addEventListener('resize', this.handleResize);
      if (!this.props.currentWarehouse) this.context.router.push('/warehouses');
      else {
        // this.props.fetchWarehouseDetail(this.props.currentWarehouse);
        this.props.fetchWarehouseBins(this.props.currentWarehouse.Warehouse_id);
      }
    }

    componentWillReceiveProps(nextProps) {

      // if(nextProps.zones && nextProps.zones != this.props.zones && this.props.warehouseBinsDetail){
      //   let newRows = nextProps.zones;
      //
      //   newRows.map(zone => {
      //     const index = _.findIndex(this.props.warehouseBinsDetail.Warehouse_Zone, {'WarehouseZone_id': zone['WarehouseZone_id']});
      //     if(index != -1){
      //       zone['AvailableBin'] = this.props.warehouseBinsDetail.Warehouse_Zone[index].AvailableBin;
      //       zone['TotalBin'] = this.props.warehouseBinsDetail.Warehouse_Zone[index].TotalBin;
      //       zone['UsedBin'] = this.props.warehouseBinsDetail.Warehouse_Zone[index].TotalBin - this.props.warehouseBinsDetail.Warehouse_Zone[index].AvailableBin;
      //
      //     }
      //   });
      //   this.setState({rows: newRows});
      // }
      if (nextProps.warehouseBinsDetail && nextProps.warehouseBinsDetail !== this.props.warehouseBinsDetail && this.props.zones) {
        let newRows = nextProps.warehouseBinsDetail.Warehouse_Zone;
        newRows.map(zone => {
          zone['UsedBin'] = zone['TotalBin'] - zone['AvailableBin'];
        })
        this.setState({rows: newRows, allRows: newRows});
      }

      if (this.props.nameValue && !nextProps.nameValue) {
        let rows = this.state.allRows
        this.setState({rows: rows});
      }

      if (nextProps.deleteZoneSuccess && nextProps.deleteZoneSuccess!= this.props.deleteZoneSuccess) {
        this.props.fetchWarehouseBins(this.props.currentWarehouse.Warehouse_id);
      }
      // handle errors
      if (nextProps.deleteZoneFailureError && !this.props.deleteZoneFailureError) {
        alert(nextProps.deleteZoneFailureError);
      }
      if (nextProps.deleteBinSuccess && nextProps.deleteBinSuccess !== this.props.deleteBinSuccess) {
        this.getBins(this.state.zone.WarehouseZone_id);
      }
      if (nextProps.deleteLevelSuccess && nextProps.deleteLevelSuccess !== this.props.deleteLevelSuccess) {
        this.getLevels(this.state.binRow.id);
      }
      if (nextProps.createBinSuccess && nextProps.createBinSuccess !== this.props.createBinSuccess) {
        this.getBins(this.state.zone.WarehouseZone_id);
      }
      if (nextProps.createLevelSuccess && nextProps.createLevelSuccess !== this.props.createLevelSuccess) {
        this.getLevels(this.state.binRow.id);
      }
      if (nextProps.createError && !this.props.createError) {
        alert(nextProps.createError);
      }
      if (nextProps.levelCreateError && !this.props.levelCreateError) {
        alert(nextProps.levelCreateError);
      }
      if (nextProps.editError && !this.props.editError) {
        alert(nextProps.editError);
      }
      if (nextProps.binCreateError && !this.props.binCreateError) {
        alert(nextProps.binCreateError);
      }
      if (nextProps.attachDocumentSuccess && this.props.attachDocumentSuccess !== nextProps.attachDocumentSuccess) {
        this.props.fetchWarehouseBins(this.props.currentWarehouse.Warehouse_id);
      }
      if (nextProps.updatedLevel && this.props.updatedLevel !== nextProps.updatedLevel) {
        this.getLevels(this.state.binRow.id);
        this.setState({
          selectedLevelRows: [],
        });
      }
      if (nextProps.updatedBin && this.props.updatedBin !== nextProps.updatedBin) {
        this.getBins(this.state.zone.WarehouseZone_id);
        this.setState({
          selectedBinRows: [],
        });
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize(e) {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton });
    }

    openModal() { this.setState({ modalOpen: true }); }
    openZone() { this.setState({ zoneOpen: true }); }
    openBin() { this.setState({ binOpen: true }); }
    closeBin() { this.setState({ binOpen: false }); }
    openLevel() { this.setState({ levelOpen: true }); }
    closeLevel() { this.setState({ levelOpen: false }); }
    closeZone() { this.setState({ zoneOpen: false }); }
    closeModal() { this.setState({ modalOpen: false }); }
    binOpenSave() { this.setState({ binSaveOpen: true }); }
    binCloseSave() { this.setState({ binSaveOpen: false }); }
    levelCloseSave() {this.setState({ levelSaveOpen: false }); }
    levelOpenSave() { this.setState({ levelSaveOpen: true }); }

    deleteZone(e) {
      e.preventDefault();
      const currentZone= this.state.selectedRows[0];
      this.props.deleteZone(currentZone.WarehouseZone_id);
      this.closeModal();
    }

    deleteBin(e) {
      e.preventDefault();
      const currentBin = this.state.selectedBinRows[0].id;
      this.props.deleteBinsBD(currentBin);
      this.closeBin();
    }

    deleteLevel(e) {
      e.preventDefault();
      const currentLevel = this.state.selectedLevelRows[0].id;
      this.props.deleteBin(currentLevel);
      this.closeLevel();
    }

    handleFormSubmit(formProps) {
        if (this.props.currentWarehouse) this.props.editWarehouse(formProps);
        else this.props.createWarehouse(formProps);
    }

    viewZone(id) {
        this.props.resetCurrentZone();
        this.props.selectZone(id);
        this.context.router.push("/zoneDetail");
    }

    editZone(e) {
        e.preventDefault();
        this.props.resetCurrentZone();
        const currentZone = this.state.selectedRows[0];
        this.props.selectZone(currentZone);
        this.setState({ title: <Translate value="edit_zone" /> });
        this.openZone();
    }

    editBin(e) {
      e.preventDefault();
      this.props.resetCurrentZone();
      const { selectedBinRows } = this.state;
      const currentBin = {Name: selectedBinRows[0].section_num, description: selectedBinRows[0].description}
      this.props.selectBin(currentBin);
      this.props.selectZone(currentBin);
      this.setState({ title: <Translate value="edit_bin" /> });
      this.binOpenSave();
    }

    editLevel = (e) => {
      e.preventDefault();
      this.props.resetCurrentZone();
      const { selectedLevelRows } = this.state;
      const currentLevel = {Name: selectedLevelRows[0].bin_num, description: selectedLevelRows[0].description, max_qty: selectedLevelRows[0].max_qty}
      this.props.selectLevel(currentLevel);
      this.props.selectZone(currentLevel);
      this.setState({ title: <Translate value="edit_level" /> });
      this.levelOpenSave();
    }

    createZone(e) {
        e.preventDefault();
        this.props.resetCurrentZone();
        this.setState({ title: <Translate value="add_a_new_zone" /> });
        this.openZone();
    }

    createBin(e) {
      e.preventDefault();
      this.props.resetCurrentZone();
        this.setState({ title: <Translate value="add_a_new_bin" /> });
        this.binOpenSave();
    }

    createLevel(e) {
      e.preventDefault();
      this.props.resetCurrentZone();
      this.setState({ title: <Translate value="add_a_new_level" /> });
      this.levelOpenSave();
    }

    getLevels = (id) => {
      this.props.getLevelsByBin(id)
      .then( () => {
        this.setState({
           levels: this.props.levels
        })
        this.levelCloseSave();
      })
    }

    getBins = (id) => {
      this.props.getBinsByZone(id)
      .then( () => {
        this.setState({
          bins: this.props.bins
        })
        this.binCloseSave();
      })
    }

    searchZones() {
        const { fetchWarehouseDetail, searchZones, nameValue, currentWarehouse} = this.props
        if (!nameValue) fetchWarehouseBins(currentWarehouse.Warehouse_id);
        else {
          let allrows = this.state.allRows;
          let rows = []
          rows = allrows.filter(r => {
            return r.Name == nameValue
          });
          this.setState({rows: rows});
        }
      }


      renderBarcode = () => {
        let Warehouse_id = null;
        if (this.props && this.props.currentWarehouse) {
          Warehouse_id = this.props.currentWarehouse.Warehouse_id;
        }
        // const { Warehouse_id } = this.props.currentWarehouse;
        const {currentZone, currentBin, currentLevel} = this.state;
        const {currentWarehouse} = this.props;
        let barcodeUrl;
        if (currentWarehouse) {
          let warehouseNum = currentWarehouse.warehouse_num;
          if (warehouseNum === "LE") {
            warehouseNum = "LA"
          }

          if (currentLevel) {
            let zone = encodeURIComponent(currentZone)
            let bin = encodeURIComponent(currentBin)
            let level = encodeURIComponent(currentLevel)
            if(isGFD) {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${warehouseNum}-${zone}-${bin}-${level}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            } else {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${warehouseNum}-${currentZone}-${currentBin}-${currentLevel}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            }
          } else if (currentBin) {
            let zone = encodeURIComponent(currentZone)
            let bin = encodeURIComponent(currentBin)
            if(isGFD) {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${warehouseNum}-${zone}-${bin}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            } else {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${warehouseNum}-${currentZone}-${currentBin}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            }
          } else if (currentZone) {
            let zone = encodeURIComponent(currentZone)
            if(isGFD) {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${warehouseNum}-${zone}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            } else {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${warehouseNum}-${currentZone}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            }
          } else {
            barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${warehouseNum}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
          }

          let { selectedRows } = this.state;
          let multiZoneIds = [];
          if (selectedRows.length > 0) {
            selectedRows.map((row) => {
              multiZoneIds.push(row.Name);
            });
          }
          const multiZoneIdsString = multiZoneIds.join(',');
          if (isSV) {
            if (currentLevel) {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${currentZone}-${currentBin}-${currentLevel}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            } else if (currentBin) {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${currentZone}-${currentBin}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            } else if (currentZone) {
              // barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${currentZone}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${multiZoneIdsString}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            } else {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            }
        }
      }
        return (
        <Button
          style={{margin: 5}}
          bsStyle="danger"
          type="button"
          disabled={!this.state.currentZone}
          href={barcodeUrl}
        >
        <em className="fa fa-barcode" /><Translate value="generate_barcode_10" />
        </Button>
        )
      }



      renderBarcode30 = () => {
        let Warehouse_id = null;
        if (this.props && this.props.currentWarehouse) {
          Warehouse_id = this.props.currentWarehouse.Warehouse_id;
        }
        // const { Warehouse_id } = this.props.currentWarehouse;
        const {currentZone, currentBin, currentLevel} = this.state;
        const {currentWarehouse} = this.props;
        let barcodeUrl;
        if (currentWarehouse) {
          let warehouseNum = currentWarehouse.warehouse_num;
          if (warehouseNum === "LE") {
            warehouseNum = "LA"
          }
          if (currentLevel) {
            barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode30/${warehouseNum}-${currentZone}-${currentBin}-${currentLevel}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
          } else if (currentBin) {
            barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode30/${warehouseNum}-${currentZone}-${currentBin}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
          } else if (currentZone) {
            barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode30/${warehouseNum}-${currentZone}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
          } else {
            barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode30/${warehouseNum}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
          }

          let { selectedRows } = this.state;
          let multiZoneIds = [];
          if (selectedRows.length > 0) {
            selectedRows.map((row) => {
              multiZoneIds.push(row.Name);
            });
          }
          const multiZoneIdsString = multiZoneIds.join(',');
          if (isSV) {
            if (currentLevel) {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode30/${currentZone}-${currentBin}-${currentLevel}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            } else if (currentBin) {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode30/${currentZone}-${currentBin}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            } else if (currentZone) {
              // barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode/${currentZone}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode30/${multiZoneIdsString}?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            } else {
              barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcode30/?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
            }
        }
      }
        return (
        <Button
          style={{margin: 5}}
          bsStyle="danger"
          type="button"
          disabled={!this.state.currentZone}
          href={barcodeUrl}
        >
        <em className="fa fa-barcode" /><Translate value="generate_barcode_30" />
        </Button>
        )
      }




      renderAllBarcode = () => {
        const { Warehouse_id } = this.props.currentWarehouse;
        let barcodeUrl;
        barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebinlevelbarcodeall/?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
        return (
        <Button
          style={{margin: 5}}
          bsStyle="danger"
          type="button"
          href={barcodeUrl}
        >
        <em className="fa fa-barcode" /><Translate value="generate_all_barcode" />
        </Button>
        )
      }

      renderAllZoneBarcode = () => {
          let barcodeUrl;
          barcodeUrl = `${ROOT_URL}v1/warehouse/printzonebarcodeall/?Bearer=${localStorage.getItem('token')}`;
          return (
          <Button
            bsStyle="danger"
            type="button"
            href={barcodeUrl}
          >
          <em className="fa fa-barcode" /><Translate value="generate_all_zone_barcode" />
          </Button>
          )
        }

      onDrop = (file) => {
        if (file) {
          alert("Please stay on the current page while the file uploads.");
        }
        this.props.attachZoneBinLevel(file[0], this.props.currentWarehouse.id);
        this.setState({
          file: file
        })
      }

      importZoneBinLevel = () => {
        let Warehouse_id = null;
        if (this.props && this.props.currentWarehouse && this.props.currentWarehouse.Warehouse_id) {
          Warehouse_id = this.props.currentWarehouse.Warehouse_id;
        }
        // const { Warehouse_id } = this.props.currentWarehouse;
        const csvUrl = `${ROOT_URL}v1/warehouse/zonebinlevel/export/?Bearer=${localStorage.getItem('token')}&warehouse_id=${Warehouse_id}`;
        return (
          <Button
            style={{margin: 5}}
            bsStyle="success"
            type="button"
            href={csvUrl}
          >
            <em className="fa fa-arrow-circle-o-down" />
            <Translate value="download_file" />
          </Button>
        )
      }

    renderWarehouseDetail() {
        const { detailError, detailIsLoading, currentWarehouse } = this.props;
        if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle"/>
        else if (detailError) return <div className="alert alert-danger">{JSON.stringify(detailError) }</div>
        else if (currentWarehouse) {
            // let Total_size = Math.floor(Math.random() * (100000 - 50000 + 1)) + 50000;
            const { Name, Street, City, State, FirstName, LastName, Email, Telephone, Fax, Warehouse_id } = currentWarehouse;
            const Address = Street + ", " + City + ", " + State;
            const Contact = FirstName + " " + LastName
            return (
                <div>
                    <Row><Col sm={ 12 }><h4><Translate value="warehouse_name" />: {Name || <Translate value="name" />}</h4></Col></Row>
                    <Row><Col sm={ 12 }><Translate value="warehouse_id" />: {Warehouse_id}</Col></Row>
                    <Row className="marginTopStyle"><Col sm={ 12 }><em className="fa fa-building-o marginRightStyle"/>{Address || <Translate value="address" />}</Col></Row>
                    <Row className="marginTopStyle"><Col sm={ 12 }><em className="fa fa-user marginRightStyle" />{Contact || <Translate value="contact_person" />}</Col></Row>
                    <Row className="marginTopStyle"><Col sm={ 12 }><em className="fa fa-envelope marginRightStyle" />{Email || <Translate value="email" />}</Col></Row>
                    <Row className="marginTopStyle"><Col sm={ 12 }><em className="fa fa-phone marginRightStyle" />{Telephone || <Translate value="phone" />}</Col></Row>
                    <Row className="marginTopStyle"><Col sm={ 12 }><em className="fa fa-fax marginRightStyle" />{Fax || <Translate value="fax" />}</Col></Row>
                    {/*<Row className="marginTopStyle"><Col sm={ 12 }><em className="fa fa-arrows marginRightStyle" />{Total_size || <Translate value="total_size" />} sq ft</Col></Row>*/}
                </div>
            )
        }
    }

    renderZones() {
        const { currentWarehouseDetail, zones, detailError, detailIsLoading } = this.props;
        if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
        else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
        return zones.map((zone) => {
            const { Name, WarehouseName, Description, Bin, WarehouseZone_id } = zone
            return (
                <div>
                    <br/>
                    <Panel>
                        <Row className="pull-right">
                            <em className="fa fa-trash buttonStyle"/><em className="fa fa-pencil buttonStyle" onClick={() => this.editZone(WarehouseZone_id) }/>
                        </Row>
                        <Row>
                            <Col sm={ 6 }>
                                <Row><Col sm={ 12 }>
                                    <a onClick={() => this.viewZone(WarehouseZone_id) } style={{ cursor: "pointer" }}>
                                        <em className="fa fa-institution marginRightStyle"/>
                                        <b><Translate value="zone" /> {Name || <Translate value="name" />}</b>
                                    </a>
                                </Col></Row>
                              <Row><Col sm={112 }><Translate value="warehouse_zone_id" />: {WarehouseZone_id}</Col></Row>
                                <Row><Col sm={ 12 }>
                                    <em className="fa fa-building marginLeftStyle marginRightStyle"/>
                                    {currentWarehouseDetail.Name || <Translate value="warehouse_name" />}
                                </Col></Row>
                              <Row><Col sm={ 12 } className="descriptionStyle">{Description || <Translate value="description" />}</Col></Row>
                            </Col>
                            <Col sm={ 6 }>
                                <Row><Col sm={ 12 }><Translate value="bin" />: </Col></Row>
                                <Row><Col sm={ 12 }>{JSON.stringify(Bin) }</Col></Row>
                            </Col>
                        </Row>
                    </Panel>
                </div>
            )
        })
    }

    renderZonesForm() {
      const { currentWarehouseDetail, zones, detailError, detailIsLoading } = this.props;
      if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
      else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
      else {
        const getRows = () => {
          return Data.Selectors.getRows(this.state);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }


        const onRowClick = (rowIdx, row) => {
          const grabBins = getBins(row.id, row);
          const id = row.id
          this.setState( () => {
            return {
              binSelected: false,
              levels: [],
              currentLevel: null,
              selectedLevelRows: [],
              levelSelected: false,
              zone: row }
            }, () => {
              grabBins()
            });
          }

          const getBins = (id, row) => {
            this.props.getBinsByZone(id)
            .then( () => {
              if (this.props.bins && this.props.bins !== []) {
                this.setState({
                  selectedBinRows: [],
                  binSelected: true,
                  bins: this.props.bins
                })
              }
            })
          }

        // Handle the row select function
        const onRowSelect = rows => {
            this.setState(...this.state, { selectedRows: rows });
        }

        const onRowsSelected = (rows) => {
          if (isSV) {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            let zoneId = rows[0].row.WarehouseZone_id
            // newRows.map(r => {
            //   r.isSelected = false;
            // });
            rows.map(r => {
              newRows[r.rowIdx].isSelected = true;
              selectedRows.push(r.row);
            });
            this.setState((state, props) => {
              return {
                selectedLevelRows: [],
                levels: [],
                zone: selectedRows[0],
                rows: newRows,
                currentZone: selectedRows[0].zone_num,
                currentLevel: null,
                selectedRows: selectedRows }
            }, () => {
              getBins(zoneId, rows[0].row)
            });
          } else {
            let newRows = getRows();
            let selectedRows = [newRows[rows[0].rowIdx]];
            let zoneId = rows[0].row.WarehouseZone_id
            newRows.map(r => {
              r.isSelected = false;
            });
            rows.map(r => {
              newRows[r.rowIdx].isSelected = true;
            });
            this.setState((state, props) => {
              return {
                selectedLevelRows: [],
                levels: [],
                zone: selectedRows[0],
                rows: newRows,
                currentZone: selectedRows[0].zone_num,
                currentLevel: null,
                selectedRows: selectedRows }
            }, () => {
              getBins(zoneId, rows[0].row)
            });
          }
        }

        const onRowsDeselected = (rows) => {
          if (isSV) {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
              newRows[r.rowIdx].isSelected = false;
              const rowIndex = selectedRows.indexOf(r.row);
              selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows});
          } else {
            let rowIndexes = rows.map(r => r.rowIdx);
            let newRows = [...this.state.rows];
            rows.map (r => {
              newRows[r.rowIdx].isSelected = false;
            });
            this.setState({ rows: newRows, selectedRows: []});
          }
        }

        // Handle the sortable function
        const handleGridSort = (sortColumn, sortDirection) => {
            var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState(state);
        }

        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
              if(isVAK && this.props.language === 'ch' && filter.column.key === "Name" ){
                newFilters["Description"] = filter;
              }else{
                newFilters[filter.column.key] = filter;
              }
            } else {
              if(isVAK && this.props.language === 'ch' && filter.column.key === "Name"){
                delete newFilters["Description"];
              }else{
                delete newFilters[filter.column.key];
              }
            }
            this.setState({ filters: newFilters });
        }

        //Custom Formatter component
        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className="label label-danger">-</span>;
            }
        });
        // Column difinition
        const columns = [
          {
              key: 'Name',
              name: <Translate value="zone" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 140,
              getRowMetaData: row => row,
              formatter: ({value, dependentValues}) => {
                if (isVAK) {
                  return <TranslateName data={dependentValues}/>
                }
                return <div>{value}</div>
              }
          },
          {
              key: 'description',
              name: <Translate value="Description" />,
              resizable: true,
              sortable: true,
              filterable: true,
              width: 170,
          },
        ];

        return (
            <Col sm={4}>
              <div style={{ maxWidth: '99%', marginTop: '20px' }}>
                <ReactDataGrid
                  rowKey='WarehouseZone_id'
                  enableCellSelect
                  onGridSort={handleGridSort}
                  toolbar={<Toolbar enableFilter />}
                  onAddFilter={handleFilterChange}
                  columns={columns}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  enableRowSelect={isSV ? 'multi' : 'single'}
                  minHeight={this.state.tableHeight - 70}
                  rowHeight={25}
                  rowSelection={{
                    showCheckbox: true,
                    enableShiftSelect: isSV ? true : false,
                    onRowsSelected,
                    onRowsDeselected,
                    selectBy: {
                      isSelectedKey: 'isSelected'
                    }
                  }}
                  onRowClick={onRowClick}
                />
              </div>
            </Col>
        );
    }
  }

  renderBinsForm() {
    if (this.state.binSelected && this.state.bins.length) {
    const { currentWarehouseDetail, zones, detailError, detailIsLoading } = this.props;
    if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
    else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
    else {
      const getRows = () => {
          return this.state.bins;
      }

      const getSize = () => {
          return getRows().length;
      }

      const rowGetter = rowIdx => {
          var rows = getRows();
          return rows[rowIdx];
      }

      const onRowClick = (rowIdx, row) => {
        const grabLevels = getLevels(row.id, row);
        const rowId = row.id
          this.setState( (props, state) => {
            return {
              currentBin: null,
              levelSelected: false,
              currentLevel: null,
              levels: [],
              bin: rowId,
          }, () => {
            grabLevels()
          }});
        }

      const getLevels = (id, row) => {
        this.props.getLevelsByBin(id)
        .then( () => {
          if (this.props.levels) {
            this.setState( () => {
              return {
                selectedLevelRows: [],
                levelSelected: true,
                levels: this.props.levels,
                bin: row.id,
                binRow: row,
                currentBin: row.section_num
              }
            })
          }
        })
      }

      // Handle the row select function
      const onRowSelect = rows => {
          this.setState(...this.state, { selectedRows: rows });
      }

      const onRowsSelected = (rows) => {
        let newRows = getRows();
        let selectedRows = [newRows[rows[0].rowIdx]];
        let binId = rows[0].row.id;
          newRows.map(r => {
            r.isSelected = false;
          });
          rows.map(r => {
            newRows[r.rowIdx].isSelected = true;
          });
          this.setState( (props, state) => {
            return {
            binRows: newRows,
            currentLevel: null,
            currentBin: selectedRows[0].section_num,
            selectedBinRows: selectedRows }
          }, () => {
            getLevels(binId, rows[0].row);
          })
      }

      const onRowsDeselected = (rows) => {
          let rowIndexes = rows.map(r => r.rowIdx);
          let newRows = [...this.state.binRows];
          rows.map (r => {
            newRows[r.rowIdx].isSelected = false;
          });
          this.setState( () => {
            return {
              binRows: newRows,
              selectedBinRows: [],
              currentBin: null,
              currentLevel: null,
            }
          });
        }

     const handleGridSort = (sortColumn, sortDirection) => {
        const comparer = (a, b) => {
          if (sortDirection === 'ASC') {
              return (a[sortColumn]> b[sortColumn]) ? 1 : -1;
            } else if (sortDirection === 'DESC') {
              return (a[sortColumn]< b[sortColumn]) ? 1 : -1;
            }
        };
        const bins = sortDirection === 'NONE' ? this.state.bins.slice(0) : this.state.bins.sort(comparer);
        this.setState({bins});
      }

      const handleFilterChange = filter => {
          let newFilters = Object.assign({}, this.state.binFilters);
          if (filter.filterTerm) {
              newFilters[filter.column.key] = filter;
          } else {
              delete newFilters[filter.column.key];
          }
          this.setState({ binFilters: newFilters });
      }

      //Custom Formatter component
      const DateFormatter = React.createClass({
          render() {
              if (this.props.value) {
                let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                let date = new Date(this.props.value)
                let index = dateMap.indexOf(date.toString().slice(4,3));
                let localDate = index + date.toString().slice(8, 6);
                return <span>{date.toString().slice(4, 15)}</span>;;
              }
              else return <span className="label label-danger">-</span>;
          }
      });

      // Column difinition
      const columns = [
        {
            key: 'section_num',
            name: <Translate value="Bin" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 140,
        },
        {
            key: 'description',
            name: <Translate value="Description" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 170,
        },

      ];

      return (
          <Col sm={4}>
            <ButtonToolbar className="table-buttons">
            <Button disabled={!this.state.currentBin} onClick={(event) => this.createLevel(event) } ><em className="fa fa-plus" /><Translate value="add_level" /></Button>
              <Button
                bsStyle="warning"
                type="button"
                onClick={(event) => { this.editBin(event) } }
                disabled={!this.state.currentBin || !this.state.selectedBinRows.length}>
                <em className="fa fa-pencil" />
                <Translate value="edit" />
              </Button>
              <Button
                bsStyle="danger"
                type="reset"
                onClick={(event) => { this.openBin(event) }  }
                disabled={this.state.levels.length || !this.state.selectedBinRows || !this.state.currentBin}>
                <em className="fa fa-trash-o" /><Translate value="delete" />
              </Button>
              </ButtonToolbar>
            <div style={{ maxWidth: '99%' }} id="bins datagrid">
              <ReactDataGrid
                rowKey='zone_id_id'
                enableCellSelect
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect='single'
                minHeight={this.state.tableHeight - 70}
                rowHeight={25}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected'
                  }
                }}
                onRowClick={onRowClick}
              />
            </div>
          </Col>
      );
              }
  } else {
    return (<div />)
    }
}


renderLevelsForm() {
  if (this.state.levelSelected && this.state.levels.length && this.state.bins) {
  const { detailError, detailIsLoading } = this.props;
  if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
  else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
  else {
    const getRows = () => {
        return this.state.levels;
    }

    const getSize = () => {
        return getRows().length;
    }

    const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
    }

    // Handle the row select function
    const onRowSelect = rows => {
        this.setState(...this.state, { selectedLevelRows: rows });
    }

    const onRowsSelected = (rows) => {
        let newRows = getRows();
        let selectedRows = [newRows[rows[0].rowIdx]];
        newRows.map(r => {
          r.isSelected = false;
        });
        rows.map(r => {
          newRows[r.rowIdx].isSelected = true;
        });
        this.setState({ levelRows: newRows, selectedLevelRows: selectedRows, currentLevel: selectedRows[0].bin_num });
    }

    const onRowsDeselected = (rows) => {
        let rowIndexes = rows.map(r => r.rowIdx);
        let newRows = [...this.state.rows];
        rows.map (r => {
          newRows[r.rowIdx].isSelected = false;
        });
        this.setState({ levelRows: newRows, selectedLevelRows: [], currentLevel: null });
    }

    const onRowClick = (rowIdx, row) => {
    }
    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const comparer = (a, b) => {
        if (sortDirection === 'ASC') {
            return (a[sortColumn]> b[sortColumn]) ? 1 : -1;
          } else if (sortDirection === 'DESC') {
            return (a[sortColumn]< b[sortColumn]) ? 1 : -1;
          }
      };
      const levels = sortDirection === 'NONE' ? this.state.levels.slice(0) : this.state.levels.sort(comparer);
      this.setState({levels});
    }

    const handleFilterChange = filter => {
        let newFilters = Object.assign({}, this.state.levelFilters);
        if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
        } else {
            delete newFilters[filter.column.key];
        }
        this.setState({levelFilters: newFilters})
    }

    //Custom Formatter component
    const DateFormatter = React.createClass({
        render() {
            if (this.props.value) {
              let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
              let date = new Date(this.props.value)
              let index = dateMap.indexOf(date.toString().slice(4,3));
              let localDate = index + date.toString().slice(8, 6);
              return <span>{date.toString().slice(4, 15)}</span>;;
            }
            else return <span className="label label-danger">-</span>;
        }
    });

    // Column difinition
    const columns = [
      {
          key: 'bin_num',
          name: <Translate value="Level" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 140,
      },
      {
          key: 'description',
          name: <Translate value="Description"/>,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 170,
      },
      {
        key: 'max_qty',
        name: <Translate value="capacity"/>,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 170,
      },
    ];

    if (isAGD) {
      const capacityIdx = _.findIndex(columns, { key: 'max_qty' });
      columns.splice(capacityIdx, 1);
    }
    return (
        <Col sm={4}>
          <ButtonToolbar className="table-buttons">
              <Button
                bsStyle="warning"
                type="button"
                onClick={(event) => { this.editLevel(event) } }
                disabled={!this.state.currentLevel || !this.state.selectedLevelRows.length}>
                <em className="fa fa-pencil" />
                <Translate value="edit" />
              </Button>
              <Button
                bsStyle="danger"
                type="reset"
                onClick={(event) => { this.openLevel(event) } }
                disabled={!this.state.currentLevel || !this.state.selectedLevelRows.length}>
                <em className="fa fa-trash-o" /><Translate value="delete" />
              </Button>
            </ButtonToolbar>
          <div style={{ maxWidth: '99%' }} id="levels datagrid">
            <ReactDataGrid
              rowKey='section_id_id'
              enableCellSelect
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              enableRowSelect='single'
              minHeight={this.state.tableHeight - 70}
              rowHeight={25}
              onRowClick={onRowClick}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected'
                }
              }}
            />
          </div>
        </Col>
      );
    }
  } else {
    return (<div />)
  }
}


    render() {
        const { handleSubmit, closeG, submitting, pristine, valid } = this.props;
        let height = (this.state.tableHeight + 30).toString();
        let tableCollapseFix = {height: height};
        let createDialogStyle = {
          width: '650px',
          marginLeft: '-15%',
        };
        return (
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="warehouse_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="warehouse_detail_view" />
                </Breadcrumb.Item>
              </Breadcrumb>
              <Grid fluid = "true">
                  <form method="get" action="#" onSubmit={handleSubmit(this.searchZones.bind(this)) } >
                      <Row>
                        <Col sm={ 12 }>
                          <Col sm={ 2 }>
                            <Link to="/warehouses"  className="btn btn-green buttonStyle" ><em className="fa fa-mail-reply"/></Link>
                          </Col>
                          <Col sm= {5} />
                          <Col sm={ 3 }>
                              <Field name="ZoneName" component={renderSearchField}/>
                          </Col>
                          <Col sm={ 2 }>
                              <button action="submit" className="btn btn-primary buttonStyle" disabled={ submitting || pristine || !valid } ><Translate value="save" /></button>
                          </Col>
                      </Col></Row>
                  </form>
                      <Panel className="marginTopStyle">
                          <Row><Col sm={ 12 }>
                              <Translate value="warehouse_detail_view" /> | <Translate value="warehouse" />
                          </Col></Row>
                          <br/>
                          <Row>
                            <Col sm={ 12 }>
                              {this.renderWarehouseDetail() }
                            </Col>
                            <ButtonToolbar>
                              <Button
                                style={{margin: 5}}
                                onClick={(event) => this.createZone(event) }>
                                <em className="fa fa-plus" />
                                <Translate value="add_zone" />
                              </Button>
                              {this.renderBarcode()}
                              {isSV && this.renderBarcode30()}
                              {!isSV && this.renderAllBarcode()}
                            <DropZone
                              onDrop={this.onDrop.bind(this)}
                              className="upload-button"
                            >
                              <Button
                                style={{margin: 5}}
                                bsStyle="warning"
                                type="button"
                                onClick={this.exportZoneBinLevel}
                                >
                                <em className="fa fa-arrow-circle-o-up" /><Translate value="upload_file" />
                              </Button>
                            </DropZone>
                              {this.importZoneBinLevel()}
                              </ButtonToolbar>
                          </Row>
                      </Panel>
                      <Panel style={tableCollapseFix} >
                        <Row sm={12}>
                          <Col sm={5}>
                          <ButtonToolbar className="table-buttons">
                            <Row style={{marginBottom: '5px', marginLeft: '5px'}}>
                              <Button
                                style={{marginRight: '5px'}}
                                bsStyle="warning"
                                type="button"
                                onClick={(event) => { this.editZone(event) } }
                                disabled={!this.state.currentZone}>
                                <em className="fa fa-pencil" />
                                <Translate value="edit" />
                              </Button>
                              <Button
                                style={{marginRight: '5px'}}
                                bsStyle="danger"
                                type="reset"
                                onClick={this.openModal}
                                disabled={!this.state.currentZone || this.props.bins.length}>
                                <em className="fa fa-trash-o" /><Translate value="delete" />
                              </Button>
                              {!isVAK && <Button style={{marginRight: '5px'}} onClick={(event) => this.createBin(event) }><em className="fa fa-plus" /><Translate value="add_bin" /></Button>}
                              </Row>
                              <Row style={{marginLeft: '5px'}}>
                                { isCT && this.renderAllZoneBarcode() }
                              </Row>
                          </ButtonToolbar>
                          </Col>
                        </Row>
                        <Row sm={12}>
                        {this.renderZonesForm()}
                        {this.renderBinsForm()}
                        {this.renderLevelsForm()}
                        </Row>
                      </Panel>
                      <SkyLightStateless
                        isVisible={this.state.zoneOpen}
                        onCloseClicked={() => { this.closeZone(); }}
                        title={this.state.title}>
                          <ZoneForm
                            closeG={this.closeZone}
                            hierarchy="zone"
                            value={this.state.zone ? this.state.zone : null}/>
                      </SkyLightStateless>
                      <SkyLightStateless
                        isVisible={this.state.binSaveOpen}
                        onCloseClicked={() => { this.binCloseSave(); }}
                        title={this.state.title}>
                          <ZoneForm
                            closeG={this.binCloseSave}
                            hierarchy="bin"
                            value={this.state.zone ? this.state.zone.WarehouseZone_id : null}
                            selectedBin={this.state.selectedBinRows ? this.state.selectedBinRows[0] : null}
                          />
                      </SkyLightStateless>
                      <SkyLightStateless
                        isVisible={this.state.levelSaveOpen}
                        onCloseClicked={() => { this.levelCloseSave(); }}
                        title={this.state.title}
                      >
                          <ZoneForm
                            closeG={this.levelCloseSave}
                            hierarchy="level"
                            value={this.state.bin ? this.state.bin: null}
                            selectedLevel={this.state.selectedLevelRows ? this.state.selectedLevelRows[0] : null}
                          />
                      </SkyLightStateless>
                      <SkyLightStateless
                        dialogStyles={createDialogStyle}
                        isVisible={this.state.modalOpen}
                        onCloseClicked={this.closeModal}
                        title={<Translate value="Delete Zone?" />}>
                          <br/><br/>
                          <Row className="centerStyle"><h4><Translate value="delete" />: {this.state.currentZone ? this.state.currentZone : null}?</h4></Row>
                          <br/><br/>
                          <Row className="text-center">
                            <Button onClick={(e) => this.deleteZone(e)}   className="text-center" bsStyle="primary" type="button"><Translate value="yes"/></Button>
                            <Button onClick={this.closeModal} className="text-center" bsStyle="danger" type="button"><Translate value="no"/></Button>
                          </Row>
                      </SkyLightStateless>
                      <SkyLightStateless
                        dialogStyles={createDialogStyle}
                        isVisible={this.state.binOpen}
                        onCloseClicked={this.closeBin}
                        title="Delete Bin?">
                          <br/><br/>
                          <Row className="centerStyle"><h4><Translate value="delete" />: {this.state.currentBin ? this.state.currentBin : null}?</h4></Row>
                          <br/><br/>
                          <Row className="text-center">
                            <Button onClick={(e) => this.deleteBin(e)}   className="text-center" bsStyle="primary" type="button"><Translate value="yes"/></Button>
                            <Button onClick={this.closeBin} className="text-center" bsStyle="danger" type="button"><Translate value="no"/></Button>
                          </Row>
                      </SkyLightStateless>
                      <SkyLightStateless
                        dialogStyles={createDialogStyle}
                        isVisible={this.state.levelOpen}
                        onCloseClicked={this.closeLevel}
                        title="Delete Level?">
                          <br/><br/>
                          <Row className="centerStyle"><h4><Translate value="delete" />: {this.state.currentLevel ? this.state.currentLevel : null}?</h4></Row>
                          <br/><br/>
                          <Row className="text-center">
                            <Button onClick={(e) => this.deleteLevel(e)}   className="text-center" bsStyle="primary" type="button"><Translate value="yes"/></Button>
                            <Button onClick={this.closeLevel} className="text-center" bsStyle="danger" type="button"><Translate value="no"/></Button>
                          </Row>
                      </SkyLightStateless>

              </Grid>
            </ContentWrapper>
        )
    }
}

export default WarehouseForm



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/warehouseDetail.jsx